import { render, staticRenderFns } from "./PuntoScharff.vue?vue&type=template&id=775cda08&"
import script from "./PuntoScharff.vue?vue&type=script&lang=js&"
export * from "./PuntoScharff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports